import {selectDesignerAbility} from '@packages/systems/designer-abilities';

export const selectCanAccessAiSuggestions = selectDesignerAbility(
  'canAccessAiSuggestions'
);
